import axios from "axios";
import config from "@/config";

const API_TIMEOUT = 30000; // 30s

function request(endpoint, method, data) {
  let aipUrl = config.guideApiBaseUrl + endpoint;

  return axios({
    url: aipUrl,
    timeout: API_TIMEOUT,
    method: method,
    params: method === "get" ? data : null,
    data: method === "post" ? data : null,
  }).catch(function (error) {
    return error.response;
  });
}

export { request };
